// Polyfills for Node.js modules in browser environment
import { Buffer } from 'buffer';
import process from 'process/browser';

// Make Buffer and process available globally
window.Buffer = Buffer;
window.process = process;

// Export for use in other modules
export { Buffer, process };

